const PlusIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M5.83331 10L14.1666 10" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
            <path d="M10 5.83301L10 14.1663" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
        </svg>
    )
}

export default PlusIcon
